var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayEmpty = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 32,
  height: 40,
  x: 4,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--bg-quarternary, currentColor)",
  d: "M4 4a4 4 0 0 1 4-4h16l12 12v24a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--bg-tertiary, currentColor)",
  d: "M4 4a4 4 0 0 1 4-4h16l12 12v24a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--bg-quarternary, currentColor)",
  d: "m24 0 12 12h-8a4 4 0 0 1-4-4z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray-empty.2e9def98a8144c65df25577b4af33a00.svg";